<full-calendar #calendar class="tw-absolute tw-w-full" [options]="calendarOptions()">
    <ng-template #eventContent let-arg>
        <b>{{ arg.timeText }}</b>
        <i>{{ arg.event.title }}</i>
    </ng-template>
</full-calendar>